import React from 'react';

const ContactMap = () => {
  return (
    <section className="py-0 bg-gray-950">
      <div className="max-w-7xl mx-auto px-6">
        <div className="rounded-2xl overflow-hidden border border-gray-800">
          <iframe
            title="Traain Office Location"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3544.7089847544386!2d-82.54028492395665!3d27.336460976361658!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88c340163f8c8be1%3A0x7ac7f2c44e579da!2s1343%20Main%20St%20%23205%2C%20Sarasota%2C%20FL%2034236!5e0!3m2!1sen!2sus!4v1732744000000!5m2!1sen!2sus"
            width="100%"
            height="450"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            className="grayscale"
          />
        </div>
      </div>
    </section>
  );
};

export default ContactMap;